import { createSlice } from "@reduxjs/toolkit";

export const homeData_Slice = createSlice({
    name: 'homeData_Slice',
    initialState: {},
    reducers: {
        // addData: (state, action) => {
        //     state = action.payload,
        //         console.log('action api Data', action.payload);

        // }
        setHomeData: (state, action) => {
            return { ...state, ...action.payload };
        },
    }

})


export const { setHomeData } = homeData_Slice.actions;
export default homeData_Slice.reducer; 